import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Domains = () => import('./Domains.vue');
const DomainShow = () => import('./DomainShow.vue');
const Senders = () => import('./Senders.vue');
const PostalAddress = () => import('./PostalAddress.vue');

// Mounted under /campaigns/email-campaigns so the Campaigns header (icon + tabs)
// frames Domains/Senders consistently with the rest of the Campaigns module.
// Old /settings/email-campaigns/* paths redirect to the new locations to keep
// bookmarks and email-template links working.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns/email-campaigns'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.ONE_OFF.HEADER',
        icon: 'sound-source',
      },
      children: [
        {
          path: '',
          name: 'email_campaigns_wrapper',
          meta: { permissions: ['administrator'] },
          redirect: 'domains',
        },
        {
          path: 'domains',
          name: 'email_campaigns_domains',
          meta: { permissions: ['administrator'] },
          component: Domains,
        },
        {
          path: 'domains/:domainId',
          name: 'email_campaigns_domain_show',
          meta: { permissions: ['administrator'] },
          component: DomainShow,
        },
        {
          path: 'senders',
          name: 'email_campaigns_senders',
          meta: { permissions: ['administrator'] },
          component: Senders,
        },
        {
          path: 'postal-address',
          name: 'email_campaigns_postal_address',
          meta: { permissions: ['administrator'] },
          component: PostalAddress,
        },
      ],
    },
    // Legacy redirects from the previous /settings/email-campaigns/* paths.
    {
      path: frontendURL('accounts/:accountId/settings/email-campaigns'),
      redirect: to => ({ name: 'email_campaigns_domains', params: to.params }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/email-campaigns/domains'),
      redirect: to => ({ name: 'email_campaigns_domains', params: to.params }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/email-campaigns/domains/:domainId'
      ),
      redirect: to => ({
        name: 'email_campaigns_domain_show',
        params: to.params,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/email-campaigns/senders'),
      redirect: to => ({ name: 'email_campaigns_senders', params: to.params }),
    },
  ],
};
